module.exports = __webpack_public_path__ + "img/ThemeIcons.12b077bd.svg";